import "./languageTranslateTable.css";
import axios from "axios";
import { useState, useEffect } from "react";
import { useGlobalContext } from "../../Context/Context";

const LanguageTranslateTable = ({ translateID }) => {
  const [allWords, setAllWords] = useState([]);
  const [translations, setTranslations] = useState({});
  const { selectedLanguage, loggedUser } = useGlobalContext();
  const { baseUrl } = useGlobalContext();
  const { typeButton, letterSize, boldItalic, fontSize, fontStyle } =
    useGlobalContext();

  console.log(selectedLanguage);
  console.log(loggedUser);

  const handleConvertText = (text) => {
    console.log(text);
    if (letterSize === undefined || letterSize === null) {
      return text;
    }
    if (letterSize === 0) {
      return text.toUpperCase();
    }
    if (letterSize === 1) {
      return text[0].toUpperCase() + text.slice(1).toLowerCase();
    }
    if (letterSize === 2) {
      return text.toLowerCase();
    }
  };

  useEffect(() => {
    const fetchWords = () => {
      axios
        .post(`${baseUrl}/all_words/getWordsByLanguage.php`, {
          language: selectedLanguage.name,
        })
        .then(function (response) {
          setAllWords(response.data.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    };

    fetchWords();
  }, [localStorage.name]);

  const handleInputChange = (id, value) => {
    setTranslations({
      ...translations,
      [id]: value,
    });
  };

  const handleSaveChanges = () => {
    Object.keys(translations).forEach((id) => {
      axios
        .post(`${baseUrl}/translation_users/createWord.php`, {
          aw_id: id,
          word: translations[id],
          sentBy: loggedUser.user_email,
          translation_id: translateID,
        })
        .then(function (response) {
          console.log(response.data);
          setAllWords((prevWords) =>
            prevWords.map((word) =>
              word.aw_id === parseInt(id)
                ? { ...word, word: translations[id] }
                : word
            )
          );
        })
        .catch(function (error) {
          console.log(error);
        });
    });
  };

  const renderInputField = (logged_user, item) => {
    const inputElement = (
      <input
        placeholder="Translation"
        type="text"
        value={translations[item.aw_id] || ""}
        onChange={(e) => handleInputChange(item.aw_id, e.target.value)}
      />
    );

    if (logged_user === localStorage.getItem("initiator")) {
      return (
        <>
          <td>{inputElement}</td>
          <td>
            <h5></h5>
          </td>
          <td>
            <h5></h5>
          </td>
        </>
      );
    } else if (logged_user === localStorage.getItem("user1")) {
      return (
        <>
          <td>
            <h5></h5>
          </td>
          <td>{inputElement}</td>
          <td>
            <h5></h5>
          </td>
        </>
      );
    } else if (logged_user === localStorage.getItem("user2")) {
      return (
        <>
          <td>
            <h5></h5>
          </td>
          <td>
            <h5></h5>
          </td>
          <td>{inputElement}</td>
        </>
      );
    } else {
      return (
        <>
          <td>
            <h5></h5>
          </td>
          <td>
            <h5></h5>
          </td>
          <td>
            <h5></h5>
          </td>
        </>
      );
    }
  };

  return (
    <div className="wrapper-language-translate-table">
      <table>
        <thead>
          <tr>
            <th>Id</th>
            <th>{selectedLanguage.name.toUpperCase()}</th>
            <th>{localStorage.getItem("initiator")}</th>
            <th>{localStorage.getItem("user1")}</th>
            <th>{localStorage.getItem("user2")}</th>
          </tr>
        </thead>
        <tbody>
          {allWords.map((item) => (
            <tr key={item.aw_id}>
              <td>{item.aw_id}</td>
              <td>{item.word}</td>
              {renderInputField(localStorage.getItem("logged_user"), item)}
            </tr>
          ))}
        </tbody>
      </table>
      <button
        onClick={handleSaveChanges}
        typeButton={typeButton}
        className={
          `font-size-${parseInt(
            fontSize === undefined || fontSize === null ? 0 : fontSize / 3
          )}` +
          ` font-style-${parseInt(
            fontStyle === undefined || fontStyle === null ? 0 : fontStyle / 3
          )}`
        }
        style={
          boldItalic.find((element) => parseInt(element) === 2) !== undefined
            ? {
                fontWeight: "normal",
                fontStyle: "normal",
              }
            : boldItalic.find((element) => parseInt(element) === 1) !==
                undefined &&
              boldItalic.find((element) => parseInt(element) === 0) !==
                undefined
            ? {
                fontWeight: "bold",
                fontStyle: "italic",
              }
            : boldItalic.find((element) => parseInt(element) === 0) !==
              undefined
            ? {
                fontStyle: "italic",
              }
            : boldItalic.find((element) => parseInt(element) === 1) !==
              undefined
            ? {
                fontWeight: "bold",
              }
            : {
                fontWeight: "normal",
                fontStyle: "normal",
              }
        }
      >
        {handleConvertText("Save")}
      </button>
    </div>
  );
};

export default LanguageTranslateTable;
